import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_TRACKER = "/api/materials";

export default {
  async getMaterials(params) {
    return await Api()
      .get(RESOURCE_TRACKER, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async getStatusSummary(params) {
    return await Api()
      .get(`${RESOURCE_TRACKER}/summary`, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async createMaterial(params) {
    return Api()
      .post(RESOURCE_TRACKER, params)
      .catch((err) => errorHandler(err, null));
  },
  async updateMaterial(id, params) {
    return Api()
      .put(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async getMaterial(id, params) {
    return Api()
      .get(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async discardMaterial(id) {
    return Api()
      .delete(`${RESOURCE_TRACKER}/${id}`)
      .catch((err) => errorHandler(err, null));
  },
  async decommissionMaterial(id, params) {
    return Api()
      .post(`${RESOURCE_TRACKER}/${id}/decommission`, params)
      .catch((err) => errorHandler(err, null));
  },
  async duplicateMaterial(id, params) {
    return Api()
      .post(`${RESOURCE_TRACKER}/${id}/duplicate`, params)
      .catch((err) => errorHandler(err, null));
  },
};
